<header class="page-head" data-testid="fractionation-section">
  <div class="page-head__identity">
    <span class="page-head__icon"><i class="fa fa-list-alt"></i></span>
    <div>
      <h1 class="page-head__title" data-testid="route-title">
        Detalhamento de rota: {{ routeData?.name ?? configurationForm.get('routeName').value ?? 'Nova Rota' }}
        <!-- Canal da rota (RCS, 17tm466frtx). -->
        <span class="m8v-status-pill m8v-status-pill--sm channel-chip" [class.m8v-status-pill--cool]="isRcs"
          [class.m8v-status-pill--ok]="!isRcs" data-testid="route-channel">{{ isRcs ? 'RCS' : 'SMS' }}</span>
      </h1>
      <p class="page-head__subtitle" *ngIf="routeId != 'new' && !loadingRoute" data-testid="route-summary">
        {{ carriers.controls.length }} {{ carriers.controls.length === 1 ? 'operadora' : 'operadoras' }}
        · {{ totalOutputsCount() }} {{ totalOutputsCount() === 1 ? 'saída' : 'saídas' }}
      </p>
    </div>
  </div>
  <div class="page-head__actions">
    <button
      *ngIf="routeId != 'new'"
      type="button"
      class="sf-btn sf-btn--secondary sf-btn--pill"
      (click)="editRoute()"
      data-testid="btn-rename"
    >
      <i class="fa fa-pencil"></i> Renomear
    </button>
    <button type="button" class="sf-btn sf-btn--secondary sf-btn--pill" (click)="redirectBack()" data-testid="btn-back">
      <i class="fa fa-chevron-left"></i> Voltar
    </button>
    <button
      *ngIf="routeId == 'new'"
      type="button"
      class="sf-btn sf-btn--primary sf-btn--pill"
      (click)="createRoute()"
      data-testid="btn-create"
    >
      <i class="fa fa-check"></i> Criar
    </button>
    <button
      *ngIf="routeId != 'new'"
      type="button"
      class="sf-btn sf-btn--primary sf-btn--pill"
      (click)="saveValues()"
      [appLoadingButton]="saving"
      data-testid="btn-save"
    >
      <i class="fa fa-save"></i> Salvar
    </button>
  </div>
</header>

<app-skeleton
  *ngIf="loadingRoute"
  variant="text"
  [count]="6"
  label="Carregando a rota"
  data-testid="route-loading"
></app-skeleton>

<div class="alert alert-info route-notice" *ngIf="isRcs" data-testid="rcs-edit-notice">
  <i class="fa fa-info-circle"></i>
  <span>
    Só aparecem os provedores <strong>RCS liberados pelo time de desenvolvimento</strong> (provedor novo entra por
    código). No envio, a rota fica só com as contas onde a marca do cliente está ativa, e as porcentagens de cada
    operadora são redistribuídas entre elas.
  </span>
</div>

<div class="alert alert-danger route-notice" *ngIf="!loadingRoute && anyCarrierOutputsMissing" data-testid="any-carrier-notice">
  <i class="fa fa-exclamation-triangle"></i>
  <span>
    Inclua pelo menos uma opção para <strong>"Qualquer operadora"</strong> configurada. É a
    saída usada quando a operadora do número não tem regra própria.
  </span>
</div>

<div class="m8v-carrier-toolbar" [hidden]="loadingRoute">
  <button type="button" class="sf-btn sf-btn--secondary" (click)="addCarrierRow()" data-testid="btn-add-carrier">
    <i class="fa fa-plus-circle"></i> Adicionar nova operadora
  </button>
</div>

<div class="m8v-carrier" *ngFor="let carrier of carriers.controls; let i = index" data-testid="carrier-card">
  <div class="m8v-carrier__hd">
    <span class="m8v-row-avatar"><i class="fa fa-sliders"></i></span>

    <div class="field">
      <label>Operadora</label>
      <app-search-select
        [options]="carrierSelectOptions"
        [ngModel]="carrierValue(i)"
        [ngModelOptions]="{standalone: true}"
        (selectionChange)="setCarrier(i, $event)"
        placeholder="Selecione a operadora"
        searchPlaceholder="Pesquisar operadora…"
        emptyText="Nenhuma operadora encontrada"
        noun="operadoras"
        [testId]="'fractionation-carrier-' + i"
      ></app-search-select>
    </div>

    <div class="rest">
      Porcentagem restante
      <b [class.ok]="getRowRemainingPercentage(i) === 0" [class.bad]="getRowRemainingPercentage(i) !== 0" data-testid="carrier-remaining">
        {{ getRowRemainingPercentage(i) }}%
      </b>
    </div>

    <button
      *ngIf="canRemoveCarrier(i)"
      type="button"
      class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm"
      (click)="removeCarrierRow(i)"
      ngbTooltip="Remover operadora"
      data-testid="btn-remove-carrier"
    >
      <i class="fa fa-trash"></i>
    </button>
  </div>

  <div class="m8v-carrier__bd">
    <form [formGroup]="form">
      <div formArrayName="carriers">
        <div [formGroupName]="i">
          <div class="lbl-sm">Saídas</div>

          <div formArrayName="providers">
            <div class="m8v-out-row" *ngFor="let provider of getProviders(i).controls; let j = index" [formGroupName]="j">
              <app-search-select
                [options]="providerSelectOptions"
                [ngModel]="providerValue(i, j)"
                [ngModelOptions]="{standalone: true}"
                (selectionChange)="setProvider(i, j, $event)"
                [placeholder]="isRcs ? 'Selecione a conta de provedor RCS' : 'Selecione a conta de provedor'"
                searchPlaceholder="Pesquisar conta de provedor…"
                emptyText="Nenhuma conta encontrada"
                noun="contas"
                [testId]="'fractionation-provider-' + i + '-' + j"
              ></app-search-select>

              <div class="pct">
                <input
                  type="text"
                  formControlName="percentageControl"
                  (input)="formatPercent($event)"
                  [attr.data-testid]="'fractionation-pct-' + i + '-' + j"
                />
              </div>

              <button
                type="button"
                class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm"
                (click)="removeProviderRow(carrier, j)"
                ngbTooltip="Remover saída"
                data-testid="btn-remove-provider"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>

          <div class="m8v-out-actions">
            <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="addProviderRow(carrier)" data-testid="btn-add-provider">
              <i class="fa fa-plus-circle"></i> Fracionar
            </button>

            <span class="err" *ngIf="getRowRemainingPercentage(i) !== 0" data-testid="carrier-sum-error">
              <i class="fa fa-exclamation-triangle"></i> A soma das porcentagens de cada operadora deve ser igual a 100%
            </span>
            <span class="field-hint ok-hint" *ngIf="getRowRemainingPercentage(i) === 0" data-testid="carrier-sum-ok">
              <i class="fa fa-check-circle"></i> Soma 100%
            </span>
          </div>

          <div class="m8v-split-bar" data-testid="carrier-split-bar">
            <i
              *ngFor="let provider of getProviders(i).controls; let j = index"
              [style.width.%]="providerPercentValue(provider)"
              [style.background]="splitColor(j)"
              [title]="providerPercentValue(provider) + '%'"
            ></i>
            <i
              class="missing"
              *ngIf="getRowRemainingPercentage(i) > 0"
              [style.width.%]="getRowRemainingPercentage(i)"
              [title]="'faltam ' + getRowRemainingPercentage(i) + '%'"
            ></i>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<ng-template #modalConfiguration let-modal>
  <div class="route-modal">
    <div class="modal-header">
      <div class="route-modal__head">
        <span class="route-modal__badge"><i class="fa fa-list-alt"></i></span>
        <h4 class="modal-title" data-testid="route-modal-title">
          {{ routeId == 'new' ? 'Nova rota ' + (isRcs ? 'RCS' : 'SMS') : 'Nome da configuração' }}
        </h4>
      </div>
      <button
        type="button"
        class="btn-close"
        aria-label="Fechar"
        (click)="routeId == 'new' ? cancelCreation() : cancelUpdate()"
        data-testid="btn-modal-close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <form [formGroup]="configurationForm" (ngSubmit)="modal.dismiss()">
      <div class="modal-body">
        <div class="field">
          <label for="routeName">Nome</label>
          <input
            type="text"
            formControlName="routeName"
            id="routeName"
            class="form-control"
            placeholder="Digite o nome da configuração"
            data-testid="input-route-name"
          />
        </div>

        <div class="form-check" *ngIf="routeId == 'new' && !isRcs">
          <input class="form-check-input" type="checkbox" id="routeDefault" formControlName="default" data-testid="input-default" />
          <label class="form-check-label" for="routeDefault">
            Usar como padrão <small class="field-hint">· vira a rota de todo o sistema</small>
          </label>
        </div>
        <div class="form-check" *ngIf="routeId == 'new' && !isRcs">
          <input class="form-check-input" type="checkbox" id="routeMonitored" formControlName="monitored" data-testid="input-monitored" />
          <label class="form-check-label" for="routeMonitored">Saída monitorada</label>
        </div>
        <div class="form-check" *ngIf="routeId == 'new' && !isRcs">
          <input class="form-check-input" type="checkbox" id="routePix" formControlName="pix" data-testid="input-pix" />
          <label class="form-check-label" for="routePix">Rota Pix</label>
        </div>
      </div>

      <div class="modal-footer" *ngIf="routeId == 'new'">
        <button type="submit" class="sf-btn sf-btn--primary" (click)="createConfiguration()" data-testid="btn-modal-create">Criar</button>
        <button type="button" class="sf-btn sf-btn--secondary" (click)="cancelCreation()" data-testid="btn-modal-cancel">
          Cancelar
        </button>
      </div>
      <div class="modal-footer" *ngIf="routeId != 'new'">
        <button type="submit" class="sf-btn sf-btn--primary" (click)="updateConfiguration()" data-testid="btn-modal-save">Salvar</button>
        <button type="button" class="sf-btn sf-btn--secondary" (click)="cancelUpdate()" data-testid="btn-modal-cancel">
          Cancelar
        </button>
      </div>
    </form>
  </div>
</ng-template>
